import Headroom from 'headroom.js';
import debounce from 'lodash/debounce';
import {checkVerticalresize, getHeight, toggleBodyScroll, triggerEvent} from '../base/utils';
import SearchBar from './search-bar';

class TopBar {
    constructor($element) {
        if (!$element)
            return;

        this.$mainHeader = $element;
        this.$mainHeaderWrap = $element.querySelector('.header-wrap');
        this.$breadcrumb = document.querySelector('.breadcrumb-wrap');
        this.$breadcrumbTitle = this.$breadcrumb ? this.$breadcrumb.querySelector('li:last-child') : null;
        this.$menuTrigger = $element.querySelector('.js-menu-trigger');
        this.$langTrigger = $element.querySelector('.js-lang-trigger');
        this.$langList = $element.querySelector('.js-lang-list');

        this.$submenuTrigger = $element.querySelectorAll('.submenu-toggle > a');
        this.$submenuLvl2 = $element.querySelectorAll('.menu-level-1-item .submenu');
        this.$menuBack = $element.querySelectorAll('.menu-back');

        this.windowWidth = window.innerWidth;

        this.initTopBar();
        this.initHeadroom();
        this.initMenu();
        this.initLang();
        // this.initSearch();
        new SearchBar($element, this);
    }

    initTopBar() {
        window.addEventListener('resize', debounce(this.preventAnimation.bind(this), 0));
        window.addEventListener('resize', debounce(this.conditionalHandleResize.bind(this), 100));
        window.addEventListener('scroll', debounce(this.fixBreadcrumb.bind(this), 50, {trailing: true}));
        window.addEventListener('load', this.handleResize.bind(this));
        this.setHeight();
    }

    initHeadroom() {
        let headroom = new Headroom(document.body, {
            tolerance: {
                up: 20,
                down: 0
            }
        });

        headroom.init();
    }

    fixBreadcrumb() {
        if (!this.$breadcrumb)
            return;

        let top = (window.pageYOffset || document.documentElement.scrollTop) === 0;

        if (top) {
            clearTimeout(this.timeout);
            this.$breadcrumb.classList.add('on-top');
            this.$breadcrumb.classList.remove('not-on-top');
            this.$breadcrumb.classList.remove('nowrap');
        } else {
            clearTimeout(this.timeout);
            this.$breadcrumb.classList.add('not-on-top');
            this.$breadcrumb.classList.remove('on-top');
            this.timeout = setTimeout(() => {
                this.$breadcrumb.classList.add('nowrap');
            }, 400);
        }
    }

    conditionalHandleResize() {
        checkVerticalresize(this.windowWidth, () => {
            this.handleResize();
        });
    }

    handleResize() {
        this.windowWidth = window.innerWidth;

        this.setHeight();
        this.resizeMenu();
        this.setSubmenuHeights();
    }

    preventAnimation() {
        checkVerticalresize(this.windowWidth, () => {
            this.$mainHeader.classList.add('no-animation');
            setTimeout(() => { this.$mainHeader.classList.remove('no-animation'); }, 600);
        });
    }

    resizeMenu() {
        let isOpen = document.body.classList.contains('menu-open');

        if (this.windowWidth >= 1024 && isOpen) {
            this.toggleMenu(false);
        }
    }

    setHeight() {
        let headerHeight = Math.min(getHeight(this.$mainHeaderWrap, 'full'), 150),
            breadcrumbHeight = 0,
            titleHeight = 0;

        if (this.$breadcrumb) {
            if (window.innerWidth < 1024) {
                breadcrumbHeight = getHeight(this.$breadcrumb, 'full', 200, () => {
                    this.$breadcrumbTitle.style.maxHeight = 'none';
                    titleHeight = this.$breadcrumbTitle.offsetHeight;
                });

                this.$breadcrumb.style.top = headerHeight + 'px';
                this.$breadcrumbTitle.style.maxHeight = titleHeight + 'px';
            } else {
                this.$breadcrumbTitle.style.maxHeight = '';
                this.$breadcrumb.style.top = '';
            }
        }

        document.body.style.paddingTop = breadcrumbHeight + 'px';
        document.body.style.borderTopWidth = headerHeight + 'px';
    }

    initMenu($context = document) {
        this.setSubmenuHeights();

        this.$menuTrigger.addEventListener('click', e => this.toggleMenu());

        [...this.$submenuTrigger].forEach(el => {
            el.addEventListener('click', this.toggleSubmenu.bind(this));
        });
        [...this.$menuBack].forEach(el => {
            el.addEventListener('click', this.closeSubmenu.bind(this));
        });
    }

    setSubmenuHeights() {
        [...this.$submenuLvl2].forEach(el => {
            el.style.maxHeight = el.querySelector('.submenu-wrap').offsetHeight + 'px';
        });
    }

    toggleMenu(doOpen) {
        if (typeof doOpen === 'undefined') {
            doOpen = !document.body.classList.contains('menu-open');
        }

        document.body.classList.toggle('menu-open');
        triggerEvent(document.body, 'menu', doOpen);
        toggleBodyScroll(doOpen);
    }

    toggleSubmenu(e) {
        if (document.body.classList.contains('menu-open')) {
            e.preventDefault();

            e.target.parentNode.classList.toggle('active');
        }
    }

    closeSubmenu(e) {
        let $menuItem = e.target.parentNode.parentNode;

        e.preventDefault();

        $menuItem.classList.remove('active');
        $menuItem.querySelector('a').focus();
    }

    initLang() {
        this.$langTrigger.addEventListener('click', e => {
            this.$langList.classList.toggle('lang-open');

            document.body.parentNode.addEventListener('click', this.outsideClick.bind(this));
        });
    }

    outsideClick(e) {
        if (!this.$langList.contains(e.target) && !this.$langTrigger.contains(e.target)) {
            e.preventDefault();
            this.$langList.classList.remove('lang-open');
        }
    }
}

export default TopBar;
